import { X } from "lucide-react";
import { useRef } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "./dialog";

const ModalPopup = ({
  open,
  onClose,
  title,
  description,
  children,
  actionButton,
  className = "",
  width = "w-[35%]",
  isCloseIconNeeded = true,
  containerRef
}) => {

  const closeBtnRef = useRef(null);

  return (
    <Dialog
      open={open} onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}>
      <DialogContent
        containerRef={containerRef}
        onOpenAutoFocus={(e) => {
          e.preventDefault();          // stop Radix default focus
          closeBtnRef.current?.focus(); // focus X icon
        }}
        className={` ${width} ${className} sm:rounded-lg bg-primary-foreground shadow-xl border`}
      >
        {title && (
          <DialogHeader className="grow-0">
            <div className="flex items-center justify-between">
              <DialogTitle className="text-lg font-semibold">
                {title}
              </DialogTitle>

              {isCloseIconNeeded && (
                <DialogClose asChild>
                  <button
                    ref={closeBtnRef}
                    type="button"
                    className="
                      rounded-sm p-1
                      opacity-70 hover:opacity-100
                      focus-visible:outline-none
                      focus-visible:ring-2
                      focus-visible:ring-ring
                      focus-visible:ring-offset-2
                    "
                  >
                    <X className="h-4 w-4" />
                    <span className="sr-only">Close</span>
                  </button>
                </DialogClose>
              )}
            </div>

            {description && (
              <DialogDescription className="text-sm text-gray-500">
                {description}
              </DialogDescription>
            )}
          </DialogHeader>
        )}

        <div className="space-y-1">{children}</div>

        {actionButton && (
          <DialogFooter>
            {actionButton}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalPopup;